import { useT } from '@hooks';
import React, { FC } from 'react';
import styled from 'styled-components';
import checkTheme from '../../../../../../src/utils/custom/checkTheme';

import items from './img/items.png';
import items2 from './img/items2.jpg';

const Container = styled.div`
	margin: 20px 0;
`;

const Title = styled.div`
	font-weight: bold;
	font-size: 24px;
	line-height: 28px;
`;

const Image = styled.img`
	margin-top: 20px;
	max-width: 100%;
`;

const LinkText = styled.div`
	margin-top: 20px;
	font-weight: 700;
	font-size: 12px;
	line-height: 14px;
	color: ${({ theme }) => theme.colors.text1};
`;

const Contacts = styled.div`
	margin-top: 5px;
	font-weight: 400;
	font-size: 12px;
	line-height: 14px;
	color: ${({ theme }) => theme.colors.text1};
`;

const Link = styled.a`
	font-weight: 400;
	font-size: 12px;
	line-height: 14px;
	color: #7d8bf7;
`;

const Featured: FC = () => {
	const { T } = useT();
	return (
		<Container>
			<Title>{T('featured')}</Title>

			{checkTheme() === 'darkMode' ? (
				<Image src={items2} alt='USA today, Forbes, WSJ, NEW YORK POST, MASHABLE' />
			) : (
				<Image src={items} alt='USA today, Forbes, WSJ, NEW YORK POST, MASHABLE' />
			)}

			<LinkText>{T('help')}</LinkText>
			<Contacts>
				{T('contact')}{' '}
				<Link href='mailto:support@verv.health' target='_blank'>
					{T('here')}
				</Link>
			</Contacts>
		</Container>
	);
};

export default Featured;
